class Nm12 extends Array {}

const nm12_api_adapter = nm12 => nm12;

const nm12_list_api_adapter = nm12 => nm12.map(nm12_api_adapter);

const createNm12List = (data = []) => {
    const nm12 = Nm12.from(data, nm12 => createNm12(nm12));
    return nm12;
};

const nm12_view_adapter = nm12 => {
    return nm12;
};

const createNm12 = ({
    id = null,
    country = null,
    // , area_km2 = null
    geom = null,
} = {}) => {
    const publicApi = {
        id,
        country,
        // area_km2,
        geom,
    };

    return Object.freeze(publicApi);
};

export {
    createNm12,
    createNm12List,
    nm12_api_adapter,
    nm12_list_api_adapter,
    nm12_view_adapter,
};
